module.exports = __webpack_public_path__ + "static/media/forwardChevron.18b86a7a.svg";